import type { ILink } from "@core-components/header/NavBar";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { Button } from "@mantine/core";
import { Link } from "react-router";
interface Props {
  label: ILink["label"];
  path?: ILink["path"];
  hiddenFrom?: ILink["hiddenFrom"];
}

const ButtonNavbarResponsive: React.FC<ILink> = ({
  label,
  hiddenFrom,
  isMenu,
  menuItems,
  path,
}) => {
  const { locationUrlBuilder } = useAppLanguage();

  const NavbarButton = ({ label, path, hiddenFrom }: Props) => (
    <Button
      className="no-spacing flex w-full justify-start text-left font-inter text-primary-white"
      component={Link}
      fw={"normal"}
      fz={"lg"}
      hiddenFrom={hiddenFrom}
      to={locationUrlBuilder(path ?? "#")}
      variant="transparent"
      w="fit-content"
    >
      {label}
    </Button>
  );

  if (isMenu) {
    return (
      <div
        className={`select-none text-primary-white mantine-hidden-from-${hiddenFrom}`}
      >
        {label}
        <div className="pl-8">
          {menuItems?.map(({ label, path }) => (
            <NavbarButton label={label} path={path} key={label?.toString()} />
          ))}
        </div>
      </div>
    );
  }

  return <NavbarButton label={label} path={path} hiddenFrom={hiddenFrom} />;
};

export default ButtonNavbarResponsive;
